export default "__VITE_ASSET__BYwKIF$M__"